/**
 * @generated SignedSource<<c36ae0ddca3fbc0981711f3b6bcf800d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckIfNewsSectionInFirstIndexSection$data = {
  readonly name?: string;
  readonly " $fragmentType": "helpersCheckIfNewsSectionInFirstIndexSection";
};
export type helpersCheckIfNewsSectionInFirstIndexSection$key = {
  readonly " $data"?: helpersCheckIfNewsSectionInFirstIndexSection$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIfNewsSectionInFirstIndexSection">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckIfNewsSectionInFirstIndexSection"
};

(node as any).hash = "43942666de12a214c86d0b2ef35d0ef1";

export default node;
